import { render, staticRenderFns } from "./CmpFgTable.vue?vue&type=template&id=4e43db44&"
import script from "./CmpFgTable.vue?vue&type=script&lang=js&"
export * from "./CmpFgTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports